export type InputVariant = "primary" | "warning";

export const variants: { [Variant in InputVariant]: string } = {
  primary: "bg-bright-grey outline-transparent hover:outline-light-grey",
  warning: "bg-button-warning-bg outline-warning text-warning",
};
